export default {
  common: {
    casino: "Kasino",
    more: "Lagi",
    searchGames: "Cari permainan",
    copied: "Disalin!",
    inputTooLong: "Input terlalu panjang, sila masukkan semula.",
    inputNameCn: "Hanya aksara Cina, huruf, nombor dan garis bawah dibenarkan",
    inputCapital: "Hanya huruf besar dan garis bawah dibenarkan",
    inputLowercaseUnderscore: "Hanya huruf kecil dan garis bawah dibenarkan",
    inputLowercase: "Hanya huruf kecil dibenarkan",
    inputNoSpace: "Sila jangan masukkan ruang kosong sahaja",
    inputValidPhone: "Sila masukkan nombor telefon yang sah",
    inputNonNumber: "Mengandungi aksara bukan nombor",
    inputNonLetter: "Mengandungi aksara bukan huruf",
    inputLetterOrNumberOnly: "Hanya huruf atau nombor dibenarkan",
    phoneFormatError: "Format nombor telefon tidak sah",
    inputLetterStartNumber: "Mesti bermula dengan huruf dan boleh mengandungi nombor",
    inputNoChinese: "Aksara Cina tidak dibenarkan",
    inputChineseOnly: "Hanya aksara Cina dibenarkan",
    emailFormatError: "Format e-mel tidak sah",
    urlFormatError: "Format URL tidak sah",
    jsonFormatError: "Format JSON tidak sah",
    networkError: "Gagal menghubungi pelayan, sila cuba lagi kemudian.",
    siteUnavailable: "Laman ini kini tidak tersedia, sila hubungi pentadbir.",
    tokenExpired: "Sesi anda telah tamat, sila log masuk semula.",
    domainNotAuthorized: "Domain tidak dibenarkan",
    demoEnvOnly: "Persekitaran demo, untuk pratonton sahaja",
    passwordLength630: "6-30 aksara",
    newPasswordSameAsOld: "Kata laluan baharu tidak boleh sama dengan kata laluan lama",
    confirmNewPassword: "Sila sahkan kata laluan baharu anda",
    passwordsDoNotMatch: "Kata laluan tidak sepadan",
    withdrawPasswordChanged: "Kata laluan pengeluaran berjaya ditukar",
    withdrawPasswordSet: "Kata laluan pengeluaran berjaya ditetapkan",
    withdrawPasswordSetFailed: "Gagal menetapkan kata laluan pengeluaran",
    phoneDigitsOnly: "Nombor telefon mestilah digit sahaja",
    phoneTooShort: "Nombor telefon terlalu pendek (min {min} digit)",
    phoneTooLong: "Nombor telefon terlalu panjang (maks {max} digit)",
    phoneInvalidPrefix: "Awalan nombor telefon tidak sah",
    rolloverAll: "Semua jenis",
    rolloverAllStats: "Semua Status",
    rolloverSuccessful: "Berjaya",
    rolloverFailed: "Gagal",
    rolloverInProgress: "Sedang Diproses",
    rolloverSuccess: "Berjaya",
    rolloverPending: "Tertunggak",
    rolloverCompleted: "Selesai",
    rolloverCancelled: "Dibatalkan",
    rolloverExpired: "Tamat Tempoh",
    walletCash: "Tunai",
    walletBonus: "Bonus",
    sourceDeposit: "Deposit",
    sourceCommission: "Komisen",
    sourceManualAdd: "Tambah Manual",
    sourceManualSubtract: "Tolak Manual",
  },
  redeemCode: {
    enterTip: "Masukkan kod tebus anda untuk menuntut ganjaran",
    placeholder: "Sila masukkan kod anda",
    redeemBtn: "TEBUS",
    pleaseEnterCode: "Sila masukkan kod tebus anda",
    redeemSuccess: "Penebusan berjaya!",
    redeemFailed: "Penebusan gagal, sila cuba lagi",
  },
}
